

export class SalesConciergeRequest {
    requestType: string;
    customerInfo: SalesConciergeCustomerInfo;
    productCountInfo: string;
    otherIssuesMessage: string;
    contactType: string;
    customContactInfo: SalesConciergeCustomContactInfo;
    requestNotes: string;
}

export class SalesConciergeExistingContactRequest {
    requestType: string;
    customerInfo: SalesConciergeCustomerInfo;
    productCountInfo: string;
    otherIssuesMessage: string;
    contactType: string;
    requestNotes: string;
}


export class SalesConciergeCustomerInfo {
    zip: number;
    customerType: string;
}

export class SalesConciergeCustomContactInfo {
    name: string;
    email: string;
    phone: number;
}
